<div class="row">

  <!-- Profile Summary -->
  <div class="col-lg-4">

    <div class="card profile-card" style="height: 100%;">

      <div class="profile-cover"></div>

      <div class="text-center px-3 pb-4">

        <img src="images/avatar1.png" class="profile-avatar" id="profilePreview">

        <h4 class="mt-3 mb-1">
          {{user.display_name}}
        </h4>

        <p class="text-muted mb-3">
          {{user.user_role[0].name}}
        </p>

        <!-- <div class="mb-3">
          <input type="file" class="form-control" id="profileImage" accept="image/*">
        </div> -->

      </div>

      <div class="card-body">

        <h5 class="mb-4">
          Account Information
        </h5>

        <div class="info-item">
          <small class="text-muted">Username</small>
          <div>{{user.user_name}}</div>
        </div>

        <div class="info-item">
          <small class="text-muted">Email</small>
          <div>{{user.email_id}}</div>
        </div>

        <div class="info-item">
          <small class="text-muted">Role</small>
          <div>{{user.user_role[0].name}}</div>
        </div>

        <div class="info-item">
          <small class="text-muted">Last Login</small>
          <div>{{user.last_login}}</div>
        </div>

        <div class="info-item">
          <small class="text-muted">Account Status</small>
          <div>
            <span class="badge bg-success" *ngIf="user.is_active">
              Active
            </span>
            <span class="badge bg-danger" *ngIf="!user.is_active">
              Un-Active
            </span>
          </div>
        </div>

      </div>
    </div>

  </div>

  <!-- Forms -->
  <div class="col-lg-8">

    <!-- Edit Profile -->
    <div class="card section-card mb-4">
      <div class="card-header section-header">
        <h5 class="mb-0">
          Edit Profile
        </h5>
      </div>

      <div class="card-body">
        <!-- <form id="profileForm"> -->

          <div class="row">

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Full Name
              </label>
              <input type="text" class="form-control" id="fullName" [(ngModel)]="frmData.display_name" required>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Desi./Dept.
              </label>
              <input type="text" class="form-control" id="designation" [(ngModel)]="frmData.desi_dept">
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Mobile Number
              </label>
              <input type="tel" class="form-control" id="mobile" [(ngModel)]="frmData.mobile_no" required>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Email
              </label>
              <input type="email" class="form-control" id="email" [(ngModel)]="frmData.email_id">
            </div>

            <!-- <div class="col-md-6 mb-3">
              <label class="form-label">
                Status
              </label>
              <select class="form-select" disabled>
                <option>Active</option>
                <option>In-Active</option>
              </select>
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Last Login Date
              </label>
              <input type="date" class="form-control" [(ngModel)]="frmData.last_login" disabled>
            </div> -->

          </div>

          <button type="submit" class="btn btn-primary btn-save" (click)="doUpdate()">
            Save Profile
          </button>

        <!-- </form> -->

      </div>
    </div>

    <!-- Change Password -->
    <div class="card section-card">
      <div class="card-header  section-header">
        <h5 class="mb-0">
          Change Password
        </h5>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-6">
            <!-- <form id="passwordForm"> -->
              <div class="mb-3">
                <label class="form-label">
                  Current Password
                </label>
                <input type="password" class="form-control" [(ngModel)]="frmChPW.old_pw" required>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  New Password
                </label>
                <input type="password" class="form-control" [(ngModel)]="frmChPW.new_pw" id="newPassword" required>
              </div>

              <div class="mb-3">
                <label class="form-label">
                  Confirm Password
                </label>
                <input type="password" class="form-control" [(ngModel)]="frmChPW.cnf_pw" id="confirmPassword" required>
              </div>

              <button type="submit" class="btn btn-success btn-save" (click)="pwUpdate()">
                Update Password
              </button>

            <!-- </form> -->

          </div>
          <div class="col-6">
            <img src="images/change-your-password.jpeg" width="300">
          </div>
        </div>
      </div>
    </div>

  </div>

</div>